import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";

const MenuActions = ({
  level,
  levelIndex,
  itemIndex,
  isVisible,
  currentIndices,
  onEdit,
  onVisibilityToggle,
  onColorEdit,
  onDelete,
  onPositionEdit,
  position,
}) => {
  const [isDeletePopupOpen, setDeletePopupOpen] = useState(false);

  const isVertical =
    level === 3 || (levelIndex === 2 && itemIndex > 0 && itemIndex < 4);

  const handleDeleteClick = () => {
    setDeletePopupOpen(true); // Open the confirmation popup
  };

  const handleConfirmDelete = () => {
    onDelete(currentIndices); // Trigger the delete callback
    setDeletePopupOpen(false); // Close the popup
  };

  const handleCancelDelete = () => {
    setDeletePopupOpen(false); // Close the popup without deleting
  };

  const renderActions = () => {
    const actions = [
      {
        icon: <ColorLensIcon />,
        onClick: () => onColorEdit(currentIndices, levelIndex),
      },
      {
        icon: isVisible ? <VisibilityIcon /> : <VisibilityOffIcon />,
        onClick: onVisibilityToggle,
      },
      {
        icon: <EditIcon />,
        onClick: () => onEdit(currentIndices, levelIndex, itemIndex),
      },
    ];

    if (level === 0) {
      actions.unshift({
        icon: <DeleteIcon />,
        onClick: handleDeleteClick, // Open the delete confirmation popup
        className: "danger",
      });
    }

    // if (level >= 0 && levelIndex < 1) {
    //   actions.unshift({
    //     icon: <SwapVertIcon />,
    //     onClick: () => onPositionEdit(currentIndices, levelIndex, position),
    //   });
    // }

    return actions.map((action, index) => (
      <button
        key={index}
        className={`icon-button ${action.className || ""}`}
        onClick={(e) => {
          e.stopPropagation();
          action.onClick();
        }}
      >
        {action.icon}
      </button>
    ));
  };

  return (
    <>
      <div
        className={`icon-container ${isVertical ? "vertical" : "horizontal"}`}
      >
        {renderActions()}
      </div>

      {/* Delete Confirmation Popup */}
      <Dialog
        open={isDeletePopupOpen}
        onClose={handleCancelDelete}
        aria-labelledby="delete-confirmation-dialog"
      >
        <DialogTitle id="delete-confirmation-dialog">
          Confirm Deletion
        </DialogTitle>
        <DialogContent>
          Are you sure you want to delete this item? This action cannot be
          undone.
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancelDelete}
            sx={{
              color: "black",
            }}
          >
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MenuActions;
